export const DEFAULT_FLOOR_CHANGE_DISTANCE = 7;
export const DEFAULT_WEIGHT = 1;
export const INITIAL_STEP_ID = 0;
export const FINAL_STEP_ID = 10000000000;
export const SECURITY_CONTROL_TAG = "#sec_control";

export const SPECIAL_TAGS: string[] = [
  "#sec_control",
  "#ramp",
  "#hall",
  "#stairs",
  "#waiting_room",
  "#entrance_hall",
  "#reception",
  "#corridor",
  "#courtyard",
  "#terrace",
  "#square",
  "#garden_area",
  "#parking",
  "#walkway",
  "#footbridge",
  "#elevator_lobby",
  "#go_up",
  "#go_down",
];

export const VALID_CUSTOM_FIELD_POI_CATEGORY_KEYS = [
  "indication_type",
  "indication_radius",
  "floor_transition_type",
  "priority",
];
